import { render, staticRenderFns } from "./admin_edit_news.vue?vue&type=template&id=499f96fa&scoped=true"
import script from "./admin_edit_news.vue?vue&type=script&lang=js"
export * from "./admin_edit_news.vue?vue&type=script&lang=js"
import style0 from "./admin_edit_news.vue?vue&type=style&index=0&id=499f96fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499f96fa",
  null
  
)

export default component.exports